import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailPegawaiRepository from '../Repositories/DetailPegawaiRepository'


class DetailPegawaiBloc {

    detailChannel = new Subject();
    rowtableChannel = new Subject();
    repository = new DetailPegawaiRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.rowtableChannel.next({status: apiResponse.INITIAL})
    }

    fetchListPresensi = async (query, cancelToken) => {
        try {
            this.rowtableChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListPresensi(query, cancelToken).then((result) => {
                this.rowtableChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.rowtableChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}

    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }
}

export default DetailPegawaiBloc